export const StatusCode = Object.freeze({
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
});

export const UserRole = {
  CUSTOMER: 'customer',
  PRACTITIONER: 'practitioner',
};

export const UnitType = Object.freeze({
  ITEM: 'item',
  HOUR: 'hour',
});

export const TransactionProcessAlias = Object.freeze({
  DEFAULT_FIXED_ITEM: 'default-fixed-item/release-1',
  DEFAULT_BOOKING: 'default-booking/release-1',
});

export const SOCIAL_PLATFORMS = [
  { key: 'facebook', label: 'Facebook' },
  { key: 'instagram', label: 'Instagram' },
  { key: 'linkedin', label: 'LinkedIn' },
];

export const SHIPPING = 'shipping';

export const ShippingOption = Object.freeze({
  SHIPPING: 'shipping',
});

export const CONDITION = [
  { key: 'new', label: 'New' },
  { key: 'new_with_tags', label: 'New with Tags' },
  { key: 'new_without_tags', label: 'New without Tags' },
  { key: 'used', label: 'Used' },
];

export const UploadStatus = Object.freeze({
  UPLOADING: 'uploading',
  DONE: 'done',
  ERROR: 'error',
});

export const acceptedVideoTypes = Object.freeze({
  'video/mp4': ['.mp4'],
  'video/avi': ['.avi'],
  'video/quicktime': ['.mov'],
  'video/x-ms-wmv': ['.wmv'],
  'video/x-matroska': ['.mkv'],
  'video/x-flv': ['.flv'],
  'video/webm': ['.webm'],
  'video/mpeg': ['.mpeg', '.mpg'],
  'video/mov': ['.mov'],
});

export const SIZE_OPTIONS_BY_CATEGORY = {
  technicalSuits: ['22', '24', '26', '28', '30', '32', '34', '36', '38', '40', '42'],
  trainingSuits: ['XS', 'SM', 'MD', 'LG', 'XL', '2X', '3X', '4X'],
  swimFins: ['XS', 'SM', 'MD', 'LG', 'XL'],
  paddles: ['S', 'M', 'L'],
  swimCaps: ['Junior', 'Adult'],
  bags_backpacks: ['Small', 'Medium', 'Large'],
  trunksTops: [
    'YXXS (6)',
    'YXS (7)',
    'YS (8)',
    'YM (10)',
    'YL (12)',
    'YXL (14)',
    'XS',
    'SM',
    'MD',
    'LG',
    'XL',
    '2X',
    '3X',
    '4X',
  ],
};

export const OfferState = Object.freeze({
  INITIAL: 'initial',
  COUNTER: 'counter',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  ALL: 'all',
});

export const OfferTransitions = Object.freeze({
  //Offers transitions
  SEND_OFFER: 'transition/send-offer',
  ACCEPT_OFFER: 'transition/accept-offer',
  DECLINE_OFFER: 'transition/decline-offer',
  COUNTER_OFFER: 'transition/counter-offer',
  ACCEPT_AFTER_COUNTER_1: 'transition/accept-after-counter-1',
  DECLINE_AFTER_COUNTER_1: 'transition/decline-after-counter-1',
  COUNTER_AFTER_COUNTER_1: 'transition/counter-after-counter-1',
  ACCEPT_AFTER_COUNTER_2: 'transition/accept-after-counter-2',
  DECLINE_AFTER_COUNTER_2: 'transition/decline-after-counter-2',
  COUNTER_AFTER_COUNTER_2: 'transition/counter-after-counter-2',
  ACCEPT_AFTER_COUNTER_3: 'transition/accept-after-counter-3',
  DECLINE_AFTER_COUNTER_3: 'transition/decline-after-counter-3',
  REQUEST_PAYMENT_AFTER_OFFER_ACCEPTED: 'transition/request-payment-after-offer-accepted',
});

export const BooleanEnum = Object.freeze({
  TRUE: true,
  FALSE: false,
});

export const CheckoutSteps = Object.freeze({
  SHIPPING: 'shipping',
  CARRIERS: 'carriers',
  PAYMENT: 'payment',
});

export const Transitions = Object.freeze({
  ACCEPT: 'transition/accept',
  RETURN_PRODUCT: 'transition/return-product',
  MARK_DELIVERED: 'transition/mark-delivered',
  RETURN_PRODUCT: 'transition/return-product',
  RECEIVED_RETURNED_PRODUCT: 'transition/received-returned-product',
});
export const LOCAL_FAVORITES_KEY = 'localFavorites';


export const TECHINICAL_SUITS = 'technical_suits'



export const TRAINING_SUIT_BRANDS = [
  { key: 'a3_performance', label: 'A3 Performance' },
  { key: 'arena', label: 'Arena' },
  { key: 'dolfin', label: 'Dolfin' },
  { key: 'finis', label: 'FINIS' },
  { key: 'iswim', label: 'iSwim' },
  { key: 'jolyn', label: 'JOLYN' },
  { key: 'mizuno', label: 'Mizuno' },
  { key: 'nike', label: 'Nike' },
  { key: 'speedo', label: 'Speedo' },
  { key: 'sporti', label: 'Sporti' },
  { key: 'tyr', label: 'TYR' },
  { key: 'xcel', label: 'Xcel' },
  { key: 'zone3', label: 'Zone3' },
  { key: 'other', label: 'Other' },
];

export const TRAINING_SUIT_FEMALE_NUMERIC_SIZES = Array.from(
  { length: 20 }, // 4,6,...,42
  (_, idx) => String(4 + idx * 2)
);

export const TRAINING_SUIT_MALE_NUMERIC_SIZES = Array.from(
  { length: 44 }, // 1..44
  (_, idx) => String(idx + 1)
);

export const TRAINING_SUIT_COLORS = [
  { key: 'black', label: 'Black' },
  { key: 'blue', label: 'Blue' },
  { key: 'brown', label: 'Brown' },
  { key: 'burgundy', label: 'Burgundy' },
  { key: 'cameo', label: 'Cameo' },
  { key: 'green', label: 'Green' },
  { key: 'gold', label: 'Gold' },
  { key: 'grey', label: 'Grey' },
  { key: 'multi_colored', label: 'Multi Colored' },
  { key: 'navy', label: 'Navy' },
  { key: 'orange', label: 'Orange' },
  { key: 'purple', label: 'Purple' },
  { key: 'pink', label: 'Pink' },
  { key: 'red', label: 'Red' },
  { key: 'silver', label: 'Silver' },
  { key: 'yellow', label: 'Yellow' },
  { key: 'white', label: 'White' },
  { key: 'other', label: 'Other' },
];

// ---------- Category-specific size helpers ----------

// Tech suits: 16–42
export const TECH_SUIT_SIZES = [
  '16',
  '18',
  '20',
  '22',
  '24',
  '26',
  '28',
  '30',
  '32',
  '34',
  '36',
  '38',
  '40',
  '42',
];

// Female training: 4–42 + alpha sizes + Other
export const TRAINING_SUIT_FEMALE_SIZES = [
  // 4–42 numeric
  ...Array.from({ length: 42 - 4 + 1 }, (_, i) => String(4 + i)),
  // letter sizes
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  'Other',
];

// Male training: XS–3XL + 1–44 + Other
export const TRAINING_SUIT_MALE_SIZES = [
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  '3XL',
  // 1–44 numeric
  ...Array.from({ length: 44 }, (_, i) => String(i + 1)),
  'Other',
];


// ---------- STATIC OPTIONS (top of file) ----------

// Resistance levels (checkboxes)
export const RESISTANCE_LEVELS = [
  { key: 'low', label: 'Low' },
  { key: 'medium', label: 'Medium' },
  { key: 'high', label: 'High' },
];

// Fins types (checkboxes)
export const FIN_TYPES = [
  { key: 'short_fin', label: 'Short Fin' },
  { key: 'long_fin', label: 'Long Fin' },
  { key: 'monofin', label: 'Monofin' },
  { key: 'scuba_snorkeling_fin', label: 'Scuba fin & Snorkeling fin' },
];

export const SWIM_CAP_SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'no_size'];

export const SWIM_CAP_BRANDS = [
  { key: 'arena', label: 'Arena' },
  { key: 'finis', label: 'FINIS' },
  { key: 'mizuno', label: 'Mizuno' },
  { key: 'nike', label: 'Nike' },
  { key: 'speedo', label: 'Speedo' },
  { key: 'sporti', label: 'Sporti' },
  { key: 'turbo', label: 'Turbo' },
  { key: 'tyr', label: 'TYR' },
  { key: 'zone3', label: 'Zone3' },
  { key: 'other', label: 'Other' },
];

export const GOGGLE_BRANDS = [
  { key: 'arena', label: 'Arena' },
  { key: 'blueseventy', label: 'Blueseventy' },
  { key: 'cressi', label: 'Cressi' },
  { key: 'dolfin', label: 'Dolfin' },
  { key: 'finis', label: 'FINIS' },
  { key: 'jaws', label: 'JAWS' },
  { key: 'nike', label: 'Nike' },
  { key: 'speedo', label: 'Speedo' },
  { key: 'sporti', label: 'Sporti' },
  { key: 'triswim', label: 'TRISWIM' },
  { key: 'tyr', label: 'TYR' },
  { key: 'other', label: 'Other' },
];

export const WEIGHT_CATEGORIES = [
  'fins',
  'snorkel',
  'stop_watch',
  'equipment_bags',
  'mats',
  'accessories'
];


export const GENDER = [
  { key: 'male', label: 'Male' },
  { key: 'female', label: 'Female' },
  { key: 'unisex', label: 'Unisex' },
  { key: 'other', label: 'Other' },
];


// Brands
export const BRANDS_FINS = [
  { key: 'arena', label: 'Arena' },
  { key: 'body_glove', label: 'Body Glove' },
  { key: 'cressi', label: 'Cressi' },
  { key: 'dafin', label: 'DaFin' },
  { key: 'dolfin', label: 'Dolfin' },
  { key: 'finis', label: 'FINIS' },
  { key: 'mares', label: 'Mares' },
  { key: 'oneill', label: "O'Neill" },
  { key: 'speedo', label: 'Speedo' },
  { key: 'sporti', label: 'Sporti' },
  { key: 'tyr', label: 'TYR' },
  { key: 'other', label: 'Other' },
];

export const BRANDS_SNORKEL = [
  { key: 'arena', label: 'Arena' },
  { key: 'finis', label: 'FINIS' },
  { key: 'speedo', label: 'Speedo' },
  { key: 'sporti', label: 'Sporti' },
  { key: 'tyr', label: 'TYR' },
  { key: 'other', label: 'Other' },
];

export const BRANDS_KICKBOARD = [
  { key: 'arena', label: 'Arena' },
  { key: 'dolfin', label: 'Dolfin' },
  { key: 'speedo', label: 'Speedo' },
  { key: 'sporti', label: 'Sporti' },
  { key: 'tyr', label: 'TYR' },
  { key: 'other', label: 'Other' },
];

export const EQUI_BAG_BAGPACKS_BRAND = [
  { key: 'TYR', label: 'TYR' },
  { key: 'Sporti', label: 'Sporti' },
  { key: 'Dolfin', label: 'Dolfin' },
  { key: 'FINIS', label: 'FINIS' },
  { key: 'Speedo', label: 'Speedo' },
  { key: 'Arena', label: 'Arena' },
  { key: 'other', label: 'Other (specify)' },
];

export const SWIM_BAG_BAGPACKS_BRAND = [
  { key: 'TYR', label: 'TYR' },
  { key: 'Sporti', label: 'Sporti' },
  { key: 'Dolfin', label: 'Dolfin' },
  { key: 'FINIS', label: 'FINIS' },
  { key: 'evo', label: 'Evo' },
  { key: 'Speedo', label: 'Speedo' },
  { key: 'Arena', label: 'Arena' },
  { key: 'other', label: 'Other (specify)' },
];

export const BAG_BAGPACKS_SIZE = [
  { key: '20L', label: '20L' },
  { key: '24L', label: '24L' },
  { key: '30L', label: '30L' },
  { key: '35L', label: '35L' },
  { key: '40L', label: '40L' },
  { key: '45L', label: '45L' },
];


export const CLOTHING_SIZE = [
  { key: 'XXS', label: 'XXS' },
  { key: 'XS', label: 'XS' },
  { key: 'S', label: 'S' },
  { key: 'M', label: 'M' },
  { key: 'L', label: 'L' },
  { key: 'XL', label: 'XL' },
  { key: 'XXL', label: 'XXL' },
  { key: '3XL', label: '3XL' },
];

export const CLOTHING_BRANDS = [
  { key: 'A3', label: 'A3' },
  { key: 'Nike', label: 'Nike' },
  { key: 'Arena', label: 'Arena' },
  { key: 'Dolfin', label: 'Dolfin' },
  { key: 'Speedo', label: 'Speedo' },
  { key: 'TYR', label: 'TYR' },
];


export const CLOTHING_COLOR = [
  { key: 'Black', label: 'Black' },
  { key: 'Gray', label: 'Gray' },
  { key: 'Navy', label: 'Navy' },
  { key: 'Blue', label: 'Blue' },
  { key: 'Red', label: 'Red' },
  { key: 'Green', label: 'Green' },
];
export const ACCESSORIES_COLOR = [
  { key: 'Black', label: 'Black' },
  { key: 'Gray', label: 'Gray' },
  { key: 'Navy', label: 'Navy' },
  { key: 'Blue', label: 'Blue' },
  { key: 'Red', label: 'Red' },
  { key: 'Green', label: 'Green' },
];

export const ACCESSORIES_BRANDS = [
  { key: 'Aeroomat', label: 'Aeroomat' },
  { key: 'Sporti', label: 'Sporti' },
  { key: 'Jade', label: 'Jade' },
  { key: 'arena', label: 'Arena' },
  { key: 'tyr', label: 'TYR' },
  { key: 'speedo', label: 'Speedo' },
  { key: 'dolfin', label: 'Dolfin' },
  { key: 'other', label: 'Other (specify)' },
];


export const KICKBOARD_COLORS = [
  { key: 'Black', label: 'Black' },
  { key: 'Blue', label: 'Blue' },
  { key: 'Green', label: 'Green' },
  { key: 'Multi Colored', label: 'Multi Colored' },
  { key: 'Navy', label: 'Navy' },
  { key: 'Orange', label: 'Orange' },
  { key: 'Pink', label: 'Pink' },
  { key: 'Purple', label: 'Purple' },
  { key: 'Red', label: 'Red' },
  { key: 'Yellow', label: 'Yellow' },
];

export const BRANDS_PULL_BUOY = [
  { key: 'arena', label: 'Arena' },
  { key: 'dolfin', label: 'Dolfin' },
  { key: 'speedo', label: 'Speedo' },
  { key: 'sporti', label: 'Sporti' },
  { key: 'tyr', label: 'TYR' },
  { key: 'other', label: 'Other' },
];

export const BRANDS_PARACHUTE = [
  { key: 'finis', label: 'FINIS' },
  { key: 'strechcordz', label: 'Strechcordz' },
  { key: 'tatengue', label: 'Tatengue' },
  { key: 'corecise', label: 'CORECISE' },
  { key: 'other', label: 'Other' },
];

export const PARACHUTE_COLORS = [
  { key: 'Black', label: 'Black' },
  { key: 'Blue', label: 'Blue' },
  { key: 'Green', label: 'Green' },
  { key: 'Navy', label: 'Navy' },
  { key: 'Yellow', label: 'Yellow' },
];

export const BRANDS_CORDS = [
  { key: 'finis', label: 'FINIS' },
  { key: 'hikeen', label: 'Hikeen' },
  { key: 'sporti', label: 'Sporti' },
  { key: 'strechcordz', label: 'Strechcordz' },
  { key: 'other', label: 'Other' },
];

export const CORDS_COLORS = [
  { key: 'Black', label: 'Black' },
  { key: 'Blue', label: 'Blue' },
  { key: 'Green', label: 'Green' },
  { key: 'Navy', label: 'Navy' },
  { key: 'Yellow', label: 'Yellow' },
];

export const TECH_WEARABLES_COLOR = [
  { key: 'black', label: 'Black' },
  { key: 'blue', label: 'Blue' },
  { key: 'yellow', label: 'Yellow' },
  { key: 'green', label: 'Green' },
  { key: 'red', label: 'Red' }
];

export const PACE_CLOCK_BRANDS = [
  { key: 'accusplit', label: 'Accusplit' },
  { key: 'finis', label: 'FINIS' },
  { key: 'colorado', label: 'Colorado' },
  { key: 'competitor', label: 'Competitor' }
];


export const STOP_WATCH_BRANDS = [
  { key: 'accusplit', label: 'Accusplit' },
  { key: 'anteqi', label: 'ANTEQI' },
  { key: 'finis', label: 'Finis' },
  { key: 'marathon', label: 'Marathon' },
  { key: 'mushportseiko', label: 'MushportSeiko' },
  { key: 'sporti', label: 'Sporti' },
  { key: 'tyr', label: 'TYR' },
  { key: 'ultrak', label: 'Ultrak' }
];

export const HEAD_SETS_BRAND = [
  { key: 'retekess', label: 'Retekess' },
  { key: 'shokz', label: 'Shokz' },
  { key: 'sonr', label: 'Sonr' }
];

export const TECH_SUIT_BRANDS = [
  { key: 'tyr', label: 'TYR' },
  { key: 'speedo', label: 'Speedo' },
  { key: 'arena', label: 'Arena' },
  { key: 'mizuno', label: 'Mizuno' },
  { key: 'finis', label: 'FINIS' },
  { key: 'a3_performance', label: 'A3 Performance' },
  { key: 'dolfin', label: 'Dolfin' },
];



export const COLORS_COMMON = [
  { key: 'black', label: 'Black' },
  { key: 'blue', label: 'Blue' },
  { key: 'clear', label: 'Clear' },
  { key: 'gold', label: 'Gold' },
  { key: 'green', label: 'Green' },
  { key: 'grey', label: 'Grey' },
  { key: 'multi_colored', label: 'Multi Colored' },
  { key: 'navy', label: 'Navy' },
  { key: 'orange', label: 'Orange' },
  { key: 'pink', label: 'Pink' },
  { key: 'purple', label: 'Purple' },
  { key: 'red', label: 'Red' },
  { key: 'silver', label: 'Silver' },
  { key: 'yellow', label: 'Yellow' },
  { key: 'white', label: 'White' },
  { key: 'other', label: 'Other' },
];

export const SNORKEL_SIZES = [
  { key: 'adult', label: 'Adult' },
  { key: 'youth', label: 'Youth' },
  { key: 'kids', label: 'Kids' },
  { key: 'one_size', label: 'One size' },
  { key: 'other', label: 'Other' },
];

export const PADDLES_SUBTYPES = [
  { key: 'hand_paddles', label: 'Hand paddles' },
  { key: 'finger_paddles', label: 'Finger paddles' },
  { key: 'gloves', label: 'Gloves' },
];

export const PADDLES_SIZES = [
  { key: 'xs', label: 'XS' },
  { key: 's', label: 'S' },
  { key: 's_m', label: 'S-M' },
  { key: 'm_l', label: 'M-L' },
  { key: 'l', label: 'L' },
  { key: 'xl', label: 'XL' },
  { key: 'xxl', label: 'XXL' },
  { key: 'other', label: 'Other' },
];

export const PADDLES_BRANDS = [
  { key: 'Arena', label: 'Arena' },
  { key: 'AquaJogger', label: 'AquaJogger' },
  { key: 'HYDRO-FIT', label: 'HYDRO-FIT' },
  { key: 'FINIS', label: 'FINIS' },
  { key: 'Sporti', label: 'Sporti' },
  { key: 'Speedo', label: 'Speedo' },
  { key: 'Strokemaker', label: 'Strokemaker' },
  { key: 'TYR', label: 'TYR' },
];

// Fins sizes (grouped)
export const FINS_ADULT_SIZES = [
  { key: 'adult_xs', label: 'Adult XS' },
  { key: 'adult_s', label: 'Adult S' },
  { key: 'adult_m', label: 'Adult M' },
  { key: 'adult_l', label: 'Adult L' },
  { key: 'adult_xl', label: 'Adult XL' },
];

export const FINS_KIDS_SIZES = [
  { key: 'kids_xxs', label: 'Kids XXS' },
  { key: 'kids_xs', label: 'Kids XS' },
  { key: 'kids_s', label: 'Kids S' },
  { key: 'kids_m', label: 'Kids M' },
  { key: 'kids_ms', label: 'Kids MS' },
  { key: 'kids_ml', label: 'Kids ML' },
  { key: 'kids_l', label: 'Kids L' },
  { key: 'kids_xl', label: 'Kids XL' },
];

export const OTHER_OPTION = { key: 'other', label: 'Other' };





